<p>support-info works!</p>
